import { render } from "./StakingRewardsBody.vue?vue&type=template&id=11912db4&scoped=true"
import script from "./StakingRewardsBody.vue?vue&type=script&lang=js"
export * from "./StakingRewardsBody.vue?vue&type=script&lang=js"

import "./StakingRewardsBody.vue?vue&type=style&index=0&id=11912db4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11912db4"]])

export default __exports__